<template>
  <div class="br-contact-form">
    <div class="br-contact-form__wrapper">
      <div class="br-contact-form__panel">
        <div class="br-contact-form__invitation">
          <div class="br-contact-form__invitation__details">
            <h1>We can’t wait to <span>meet you!</span> Tell us what you're thinking.</h1>
            <p>We'd love a quick opportunity to demo Zenvoy’s engagement tools with you. If you’re in a rush, feel free to call, email or reach out to us on LinkedIn. </p>

            <div class="br-contact-form__media">
              <video
                width="100%"
                height="100%"
                controls
                autoplay="autoplay"
                muted>
                <source
                  src="/video/zenvoy-video.mp4"
                  type="video/mp4">
                <source
                  src="/video/zenvoy-video.ogg"
                  type="video/ogg">
              </video>
            </div>
          </div>
        </div>
      </div>
      <div class="br-contact-form__panel">
        <div class="br-contact-form__agent">
          <div class="br-contact-form__agent__block-group">
            <div class="br-contact-form__agent__block">
              <div class="avatar">
                <img
                  src="/img/avatars/avatar-bill.jpg"
                  alt="">
              </div>
              <div class="br-contact-form__agent__details">
                <div class="text-group">
                  <span class="text text--highlight">Bill Webster</span>
                  <span class="text text--muted">Co-Founder & COO, Zenvoy Enterprise Services</span>
                </div>
                <div class="button-group">
                  <a
                    href="/files/bill-webster.vcf"
                    target="_blank"
                    download
                    class="button">
                    <i class="icon icon-file-download-94"/>
                  </a>
                  <a
                    href="tel:+1(310)3574696"
                    target="_blank"
                    class="button">
                    <i class="icon icon-phone-call"/>
                  </a>
                  <a
                    href="mailto:bill@zenvoy.com"
                    target="_blank"
                    class="button">
                    <i class="icon icon-letter-2"/>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/bill-webster-iii/"
                    target="_blank"
                    class="button">
                    <i class="icon icon-logo-linkedin"/>
                  </a>
                </div>
              </div>
            </div>
            <div class="br-contact-form__agent__block">
              <div class="progress">
                <div class="progress__label">
                  I’m happy to answer questions about Zenvoy
                </div>
                <div class="progress__bar">
                  <div
                    :style="{ width: progress + '%' }"
                    class="progress__status"/>
                </div>
              </div>
            </div>
          </div>

          <div class="br-contact-form__agent__block br-contact-form__agent__block--alt">
            <h3>Contact Details</h3>
            <div class="br-contact-form__agent__contact">
              <div class="list">
                <div class="list__item list__item--email">
                  <a href="mailto:bill@zenvoy.com">bill@zenvoy.com</a>
                </div>
                <div class="list__item list__item--phone">
                  <a href="tel:+1(310)3574696">+1 (310) 357-4696</a>
                </div>
                <div class="list__item list__item--address">
                  <a
                    href="https://goo.gl/maps/Np2APQeNwHodvN6i6"
                    target="_blank">11693 San Vicente Blvd, #182, Los Angeles, CA 90049</a>
                </div>
              </div>
            </div>
          </div>

          <div class="br-contact-form__agent__block br-contact-form__agent__block--alt">
            <h3>Attachments</h3>
            <div class="br-contact-form__agent__attachments">
              <div class="br-contact-form__agent__attachments__item">
                <div class="br-contact-form__agent__attachments__filetype">
                  PDF
                </div>
                <a
                  href="/files/Zenvoy_HR_Solutions.pdf"
                  target="_blank"
                  download>Zenvoy Products Presentation</a>
                <span class="text">1.3mb</span>
              </div>
              <div class="br-contact-form__agent__attachments__item">
                <div class="br-contact-form__agent__attachments__filetype">
                  PDF
                </div>
                <a
                  href="/files/Zenvoy_Brochure.pdf"
                  target="_blank"
                  download>Zenvoy Brochure</a>
                <span class="text">1.5mb</span>
              </div>
            </div>
          </div>

          <div class="button-group">
            <button
              class="button u-border-radius"
              @click.prevent="openCalendly">
              <span class="button__icon">
                <i class="icon icon-wand-11"/>
              </span>
              <span class="button__label">Schedule a quick demo</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    progress: 0
  }),
  created () {
    setTimeout(() => {
      this.progress = 78
    }, 200)
  },
  methods: {
    openCalendly () {
      window.Calendly.showPopupWidget('https://calendly.com/bill-webster/30min')
    }
  }
}
</script>
